import { defineStore } from 'pinia';
import { get, post } from '@/api.js';

const TOKEN_KEY = 'cp_token';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || null,
    admin: null,
    loading: false,
    error: null,
  }),
  getters: {
    isAuthenticated: (s) => !!s.token,
  },
  actions: {
    /**
     * On app boot — if redirected back from /auth/verify, the URL contains
     * `?token=<jwt>`. Capture it, persist, then clean URL.
     */
    bootFromUrl() {
      const params = new URLSearchParams(location.search);
      const fromUrl = params.get('token');
      if (fromUrl) {
        this.setToken(fromUrl);
        params.delete('token');
        const qs = params.toString();
        const cleaned = location.pathname + (qs ? `?${qs}` : '') + location.hash;
        history.replaceState({}, '', cleaned);
      }
    },

    setToken(token) {
      this.token = token;
      localStorage.setItem(TOKEN_KEY, token);
    },

    async requestMagicLink(email) {
      this.loading = true;
      this.error = null;
      try {
        return await post('/auth/request-magic-link', { email });
      } catch (err) {
        this.error = err.response?.data?.error || 'Network error';
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async fetchMe() {
      if (!this.token) return null;
      try {
        this.admin = await get('/auth/me');
        return this.admin;
      } catch {
        this.logout();
        return null;
      }
    },

    logout() {
      this.token = null;
      this.admin = null;
      localStorage.removeItem(TOKEN_KEY);
    },
  },
});
